export function collapseOpenItems(options) {
    const o = options || {};
    const root = o.root || document;
    const itemSelector = o.itemSelector || '.data-grid-item';
    const idAttr = o.idAttr || 'data-row-id';
    const exceptId = o.exceptId == null ? null : String(o.exceptId);
    const stateClasses = (o.stateClasses && o.stateClasses.length) ? o.stateClasses : ['details-expanded', 'actions-expanded'];
    const classSelector = stateClasses.map(c => '.' + c).join(', ');
    if (!classSelector) return;
    root.querySelectorAll(itemSelector + classSelector).forEach(item => {
        const itemId = item.getAttribute(idAttr);
        if (exceptId !== null && itemId === exceptId) return;
        item.classList.remove(...stateClasses);
    });
}
